import Vue, { PluginObject } from "vue";
import ExternalLinkWarningModal from "@/shared/plugins/link/ExternalLinkWarningModal.vue";
import externalLinkService from "@/shared/plugins/link/linkService";
import {
  LinkMobilePluginOption,
  LinkOptions,
  LinkPlugin
} from "@/shared/plugins/link/types";
import { isMobileApp } from "@/shared/mobileHelper";
import { fileViewer, inAppBrowser } from "@/shared/nativePlugins";

const LinkPluginInstaller: PluginObject<void> = {
  install (vue: typeof Vue): void {
    const ModalConstructor = Vue.extend(
      ExternalLinkWarningModal
    );

    const modalInstance = new ModalConstructor();
    modalInstance.$mount();
    document.body.appendChild(modalInstance.$el);

    const openUrl = async (
      url: string,
      mobilePlugin?: LinkMobilePluginOption
    ): Promise<void> => {
      if (isMobileApp()) {
        if (mobilePlugin === LinkMobilePluginOption.FileViewer) {
          await fileViewer.openFromUrl(url);
        } else {
          await inAppBrowser.openInExternalBrowser(url);
        }
      } else {
        window.open(url, "_blank");
      }
    };

    const plugin: LinkPlugin = {
      async open (
        url: string,
        options: LinkOptions = {}
      ): Promise<void> {

        if (!externalLinkService.requiresWarning(url)) {
          await openUrl(url, options.mobilePlugin);
          return;
        }

        const confirmed = await (
          modalInstance as any
        ).open(url);

        if (confirmed) {
          await openUrl(url);
        }
      }
    };

    vue.prototype.$link = plugin;
  }
};

export default LinkPluginInstaller;